import axios from 'axios';

const BASE_URL = 'https://education-backend.liara.run/api/auth';


// تنظیم axios برای ارسال credentials مثل Authorization header
const axiosInstance = axios.create({
  
  baseURL: BASE_URL,
  withCredentials: true // ✅ این خط خیلی مهمه برای عبور از CORS
});

export const loginTeacher = async (email, password) => {
  const response = await axiosInstance.post('/teacher/login', {
    email,
    password
  });

  // ذخیره توکن برای استفاده در درخواست‌های بعدی
  axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;

  return response.data.token;
};

export const registerTeacher = async (email, password) => {
  const response = await axiosInstance.post('/teacher/register', {
    email,
    password
  });

  return response.data;
};
